import { render, staticRenderFns } from "./index.vue?vue&type=template&id=232ae7fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./workbench.less?vue&type=style&index=0&id=232ae7fc&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232ae7fc",
  null
  
)

export default component.exports